var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-container"},[_c('YlCarousel',{attrs:{"height":"200px","typeParams":"1-3"}}),_c('NewsListContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }